const MENUITEMS = [
   {
    id:1,
    name: 'Ginger Burger',
    Category: 'Meal',
    image: "image/burger3.jpg",
    Label: 'Hot',
    Price: '100',
    discription: "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a",
    Comment:[
        {
            id: 0,
            rating:5,
            commment: "is simply dummy text the printing and typesetting ",
            author: "Himu",
            date: "26/2/23",
        },

    ]

   },

   {
    id:2,
    name: 'Thai Burger',
    Category: 'Meal',
    image: "image/burger1.jpg",
    Label: 'Normal',
    Price: '150',
    discription: "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a",
    Comment:[
        {
            id: 0,
            rating:5,
            commment: "is simply dummy text the printing and typesetting ",
            author: "Aktarujjaman",
            date: "26/2/23",
        },
        {
            id: 1,
            rating:4,
            commment: "is simply dummy text the printing and typesetting ",
            author: "Nayem",
            date: "26/2/23",
        },
        
    ]

   },

   {
    id:3,
    name: 'Chainiss Burger',
    Category: 'Meal',
    image: "image/bp1.jpg",
    Label: 'Hot Special',
    Price: '300',
    discription: "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a",
    Comment:[
        {
            id: 0,
            rating:5,
            commment: "is simply dummy text the printing and typesetting ",
            author: "Himu",
            date: "26/2/23",
        },
        {
            id: 1,
            rating:4,
            commment: "is simply dummy text the printing and typesetting ",
            author: "Nayem",
            date: "26/2/23",
        },
        {
            id: 2,
            rating:4.5,
            commment: "is simply dummy text the printing and typesetting ",
            author: "Hira",
            date: "26/2/23",
        },
        
    ]

   },

   {
    id:4,
    name: 'Bangla Burger',
    Category: 'Meal',
    image: "image/bp2.jpg",
    Label: 'Normal',
    Price: '120',
    discription: "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a",
    Comment:[
        {
            id: 0,
            rating:5,
            commment: "is simply dummy text the printing and typesetting ",
            author: "Himu",
            date: "26/2/23",
        },
        {
            id: 1,
            rating:4,
            commment: "is simply dummy text the printing and typesetting ",
            author: "Nayem",
            date: "26/2/23",
        },
        {
            id: 3,
            rating:5,
            commment: "is simply dummy text the printing and typesetting ",
            author: "Junayed",
            date: "26/2/23",
        },
    ]

   },
   {
    id:5,
    name: 'Indian Burger',
    Category: 'Meal',
    image: "image/bp1.jpg",
    Label: 'Normal',
    Price: '120',
    discription: "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a",
    Comment:[
        {
            id: 0,
            rating:5,
            commment: "is simply dummy text the printing and typesetting ",
            author: "Himu",
            date: "26/2/23",
        },
        {
            id: 1,
            rating:4,
            commment: "is simply dummy text the printing and typesetting ",
            author: "Nayem",
            date: "26/2/23",
        },
        {
            id: 3,
            rating:5,
            commment: "is simply dummy text the printing and typesetting ",
            author: "Junayed",
            date: "26/2/23",
        },
    ]

   },
   {
    id:6,
    name: 'Japaniss Burger',
    Category: 'Meal',
    image: "image/bp2.jpg",
    Label: 'Normal',
    Price: '120',
    discription: "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a",
    Comment:[
        {
            id: 0,
            rating:5,
            commment: "is simply dummy text the printing and typesetting ",
            author: "Himu",
            date: "26/2/23",
        },
        {
            id: 1,
            rating:4,
            commment: "is simply dummy text the printing and typesetting ",
            author: "Nayem",
            date: "26/2/23",
        },
        {
            id: 3,
            rating:5,
            commment: "is simply dummy text the printing and typesetting ",
            author: "Junayed",
            date: "26/2/23",
        },
    ]

   },

]

export default MENUITEMS;